<script setup lang="ts">
import {
    LazyContentTermsConditionsCs,
    LazyContentTermsConditionsDe,
    LazyContentTermsConditionsEn,
    LazyContentTermsConditionsEs,
    LazyContentTermsConditionsFr,
    LazyContentTermsConditionsIt,
    LazyContentTermsConditionsNl,
    LazyContentTermsConditionsPl,
    LazyContentTermsConditionsPt,
    LazyContentTermsConditionsRo,
    LazyContentTermsConditionsRu,
} from '#components';
import { Locale } from '~i18n/i18nConfig';

// COMPOSABLES
const { locale, tt } = useTypedI18n();
useSeoMeta({
    title: tt('seo.termsAndConditions.title'),
    ogTitle: tt('seo.termsAndConditions.title'),
    description: tt('seo.termsAndConditions.description'),
    ogDescription: tt('seo.termsAndConditions.description'),
});

const currentComponent = computed<Component>(() => {
    const componentByLocale: Record<Locale, Component> = {
        [Locale.CS]: LazyContentTermsConditionsCs,
        [Locale.DE]: LazyContentTermsConditionsDe,
        [Locale.EN]: LazyContentTermsConditionsEn,
        [Locale.ES]: LazyContentTermsConditionsEs,
        [Locale.FR]: LazyContentTermsConditionsFr,
        [Locale.IT]: LazyContentTermsConditionsIt,
        [Locale.NL]: LazyContentTermsConditionsNl,
        [Locale.PL]: LazyContentTermsConditionsPl,
        [Locale.PT]: LazyContentTermsConditionsPt,
        [Locale.RO]: LazyContentTermsConditionsRo,
        [Locale.RU]: LazyContentTermsConditionsRu,
    };

    return componentByLocale[locale.value];
});
</script>

<template>
    <div>
        <component :is="currentComponent" />
    </div>
</template>
